import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TodayIcon from "@mui/icons-material/Today";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SortIcon from '@mui/icons-material/Sort';
import dayjs from "dayjs";

function AttendanceInfo({ type, filter }) {
  return (
    <div className="border p-3 mt-3">
      <div className="d-flex justify-content-between">
        <div className="bg-light p-2 rounded pr-5">
          {type === 'week' ?

            <>
              <div className="text-dark">
                <CalendarMonthIcon fontSize="medium" /> Month :{" "}
                <span className="font-weight-bold">  {dayjs(filter.from).format('MMMM ')}</span>{" "}
              </div>
              <div className="text-dark">
                <DateRangeIcon fontSize="medium" /> Date Range :{" "}
                <span className="font-weight-bold"> {dayjs(filter.from).format('DD-MM-YYYY')} to {dayjs(filter.to).format('DD-MM-YYYY')}</span>{" "}
              </div>
              {/* <div className="text-dark">
            <TodayIcon fontSize="medium" /> Week:{" "}
            <span className="font-weight-bold"> {dayjs(filter.from).format('dddd')}  - {dayjs(filter.from).format('dddd')} </span>{" "}
          </div> */}
            </>
            :
            <>
              <div className="text-dark">
                <CalendarMonthIcon fontSize="medium" /> Month :{" "}
                <span className="font-weight-bold"> {dayjs(filter.date).format('MMMM YYYY')} </span>{" "}
              </div>
              <div className="text-dark">
                <DateRangeIcon fontSize="medium" /> Date :{" "}
                <span className="font-weight-bold"> {dayjs(filter.date).format('DD-MM-YYYY')}</span>{" "}
              </div>
              <div className="text-dark">
                <TodayIcon fontSize="medium" /> Day:{" "}
                <span className="font-weight-bold">{dayjs(filter.date).format('dddd')} </span>{" "}
              </div>
            </>
          }



        </div>
        {/* TODO: Add sorts if necessary */}
        {/* <div className="bg-light p-2 rounded">
          <div className="font-weight-bold text-center">Short By <SortIcon /></div>
          <div>

            <button className="btn btn-secondary btn-sm m-1">Department</button>
            <button className="btn btn-outline-success btn-light btn-sm m-1">Shift</button>
            <button className="btn btn-outline-success btn-light btn-sm m-1">Team</button>
            <button className="btn btn-outline-success btn-light btn-sm m-1">PMU</button>


          </div>
        </div> */}
      </div>
    </div>
  );
}

export default AttendanceInfo;
